import React from 'react';
import { Modal, Field } from '../../components/ui';
import { OTHER_FUNCTION_TYPE } from '../../utils/helpers';
import FunctionServices from './FunctionServices';

// Short fields that share a row on a phone.
const PAIRS = [['FunctionDate', 'Status'], ['StartTime', 'EndTime'], ['Venue', 'City']];

// Phone add/edit Function: full screen, thumb-sized. Name, type, then pairs:
// date | status, start | end (typed box + clock dial), venue |
// city, then the longer boxes. "New type name" appears only for "Other". The
// catering / services panel follows once the function exists.
export default function FunctionFormMobile({ vm, event }) {
  const { editing, values, fields, saving, setField, save, closeForm } = vm;
  if (!vm.open) return null;

  const isOther = values.FunctionType === OTHER_FUNCTION_TYPE;
  const one = (f) => (
    <Field key={f.key}
      label={f.key === 'FunctionTypeOther' ? 'New type name' : f.label} type={f.type || 'text'} value={values[f.key]}
      options={f.options} required={f.required} rows={f.rows}
      onChange={(v) => setField(f, v)}
    />
  );

  const paired = new Set(PAIRS.flat());
  const out = [];
  fields.forEach(f => {
    if (f.key === 'FunctionTypeOther' && !isOther) return;
    if (!paired.has(f.key)) { out.push(one(f)); return; }
    const pair = PAIRS.find(p => p[0] === f.key);
    if (!pair) return;                                   // second of a pair: drawn with the first
    const second = fields.find(x => x.key === pair[1]);
    out.push(
      <div key={pair.join('-')} className="ev-m-pair">
        {one(f)}
        {second && one(second)}
      </div>
    );
  });
  // A pair whose first half is missing still shows its second half.
  PAIRS.forEach(p => {
    if (!fields.some(x => x.key === p[0])) {
      const s = fields.find(x => x.key === p[1]);
      if (s) out.push(one(s));
    }
  });

  return (
    <Modal
      fullScreen
      className="ev-m"
      title={`${editing ? 'Edit' : 'Add'} Function`}
      onClose={closeForm}
      footer={<>
        <button className="btn light" onClick={closeForm}>Cancel</button>
        <button className="btn primary" disabled={saving} onClick={save}>{saving ? 'Saving…' : 'Save'}</button>
      </>}
    >
      {out}

      {editing
        ? <FunctionServices event={event} fn={{ ...editing, ...values }} />
        : <div className="fn-services muted" style={{ fontSize: 12.5 }}>
            Save the function first — catering and the other services are added to it afterwards.
          </div>}
    </Modal>
  );
}
